import Immutable from 'immutable';

export enum LicensePackageOptions {
  Unpaid = 'Unpaid',
  Basics = 'Basics',
  Core = 'Core',
  Complete = 'Complete',
}

export interface RawLicense {
  package: LicensePackageOptions;
  isTrial: boolean;
  trialDaysRemaining: number;
  subscriptionExpiration: string;
  salesforceId?: string;
  accountId?: string;
}

export const LicensePackageStrings: string[] = Object.values(
  LicensePackageOptions
).map((p) => p.toString());

export const licensePackageFromString = (
  packageString: string
): LicensePackageOptions => {
  const licensePackage = LicensePackageStrings.includes(packageString)
    ? LicensePackageOptions[packageString as LicensePackageOptions]
    : LicensePackageOptions[defaultPackage];
  return licensePackage;
};

export const defaultPackage = LicensePackageOptions.Unpaid;
const defaultLicense: RawLicense = {
  package: defaultPackage,
  isTrial: false,
  trialDaysRemaining: 0,
  subscriptionExpiration: '1970-01-01T00:00:00.000Z',
};

export const LicenseFactory = Immutable.Record(defaultLicense, 'License');

export class License extends LicenseFactory {}
